const testimonials = [
  {
    name: "Michael S.",
    location: "Boca Raton, FL",
    rating: 5,
    text: "I had a conference in Toronto in 5 days and realized my passport had expired. Fast Passport Center handled the expedited renewal and I had it back in 3 days. Their team answered every email and kept me calm during a stressful week.",
    service: "Passport Renewal",
  },
  {
    name: "Jennifer L.",
    location: "Delray Beach, FL",
    rating: 5,
    text: "Our family cruise was in 2 weeks and my daughter's passport was nowhere to be found. They walked us through the replacement process, told us exactly which clerk to visit, and had a new passport in her hands with time to spare. Lifesavers.",
    service: "Lost Passport Replacement",
  },
  {
    name: "David R.",
    location: "West Palm Beach, FL",
    rating: 5,
    text: "Business trip to London got moved up unexpectedly. I was panicking. Called FPC, started online the same day, shipped from West Palm overnight, and had my passport in under a week. I honestly didn't think it was possible.",
    service: "Expedited Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BocaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What South Florida Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Boca Raton, Delray Beach, and West Palm Beach who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}